import { ButtonLink, PrimaryButton } from '@designsforhealth/dfh-react-components'
import { useLocation } from '@gatsbyjs/reach-router'
import React, { FC } from 'react'
import styled from 'styled-components'

import { useAuth } from '../../../lib/auth'
import { usePageUrl } from '../../../lib/pages/hooks/usePageUrl'
import Spinner from '../../Spinner'
import CartDetailsContainer from './CartDetailsContainer'
import CartHeader from './CartHeader'
import CartModal from './CartModal'

import closeModalIcon from '../../../img/close_modal.svg'

export interface LoginToViewCartProps {
  className?: string
  toggleCartModal(): void
  isCartOpen: boolean
}

const LoginToViewCart: FC<LoginToViewCartProps> = ({ toggleCartModal, isCartOpen }) => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth()
  const location = useLocation()
  const { navigate } = usePageUrl()

  return (
    <CartModal
      allowScroll
      isOpen={isCartOpen}
      onBackgroundClick={toggleCartModal}
      onEscapeKeydown={toggleCartModal}
    >
      <CartDetailsContainer>
        <CartHeader>
          <strong>YOUR CART:</strong>
          <ButtonLink onClick={toggleCartModal} underline={false}>
            <img alt="Close cart modal" src={closeModalIcon} />
          </ButtonLink>
        </CartHeader>
        <h3>
          {isLoading || isAuthenticated ? (
            <Spinner loading />
          ) : (
            <PrimaryButton
              onClick={() => {
                loginWithRedirect({
                  // use relative path to avoid unloading application
                  appState: {
                    returnTo: location ? `${location.pathname}${location.search}` : '',
                  },
                }).catch(() => navigate('/login'))
              }}
              text="Login to view cart"
            />
          )}
        </h3>
      </CartDetailsContainer>
    </CartModal>
  )
}

const StyledLoginToViewCart = styled(LoginToViewCart)``

export default StyledLoginToViewCart
